import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './UserAdd.module.css'  
import At from "../../../../assets/Icon/At";
import Id from "../../../../assets/Icon/Id";
import Lock from "../../../../assets/Icon/Lock";
import User from "../../../../assets/Icon/User";
import { AppContext } from '../../../../providers/appProvider';
import { useUser } from '../../../../hooks/useUser';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { useTranslation } from 'react-i18next';

const CurrentUserModal = ({ isModalOpen, setIsModalOpen }) => {
    const { t } = useTranslation();
    const userResetData = {
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        password: "",
        password2: "",
        mobile: "",
    }


    const [newUser, setNewUser] = useState(userResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})
    const { userService } = useUser(-1)

    const { appState, app } = useContext(AppContext);

    const validateUser = (user) => {
        const messages = {};

        if (user.firstname.length < 2) {
            messages.firstname = { message: t('PleaseEnterFirstname'), isValid: false };
        }

        if (user.lastname.length < 2) {
            messages.lastname = { message: t('PleaseEnterLastname'), isValid: false };
        }


        if (user.mobile.length != 13) {
            messages.mobile = { message: t('Phone12DigitsRequired'), isValid: false };
        }


        if ( (user.password.length != 0) ||  (user.password2.length != 0)  ) {
            if (user.password.length < 6) {
                messages.password = { message: t('Password6CharsMinimum'), isValid: false };
            }
    
            if (user.password !== user.password2) {
                messages.password = { message: t('PasswordMismatch'), isValid: false };
            }
        }
       

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!user.email || user.email.length === 0 || !emailRegex.test(user.email)) {
            messages.email = { message: t('InvalidEmail'), isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validateUser(newUser)
    }

    const refreshData = () => {
        userService.fetchCurrentUser()
            .then(user =>   setNewUser({
                ...user,  
                password: '',
                password2: '',
              }))
            .catch(error => {
                console.error(error);
            });
    }
  
    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateUser(newUser)
        }
    }, [newUser, isFirstValidated]);

    useEffect(() => {
        if (isModalOpen) {
            refreshData()
        }
    }, [isModalOpen]);

    const saveHandle = () => { 
        const isValidate = validateUser(newUser)

        if (isValidate === true) {
            userService.updateCurrent(newUser)
                .then(response => {
                    alert('ცვლილება განხორციელდა');
                    setIsModalOpen(false)
                })
                .catch(error => {
                    console.error(error);
                    alert('შეცდომა დამეტებისას');
                });
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }

    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewUser(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const handlePhoneChange = (phone) => {
        let val = phone;
        setNewUser(prevClient => ({
            ...prevClient,
            ["mobile"]: val
        }));
 
    };

    return (
        <div>




            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        {t('UserData')}
                    </h3>
                </div>

                <div className={cl.inp2col}>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.firstname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="სახელი" name="firstname" value={newUser.firstname} onChange={handleClientChange} autoComplete="off" 
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase(); 
                                }}
                                />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.lastname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="გვარი" name="lastname" value={newUser.lastname} onChange={handleClientChange} autoComplete="off"
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();  
                                }}
                                />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                </div>

                <div className={cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS"
                            className={validates && validates.personal ? cl.input + ' ' + cl.errorInput : cl.input}
                            placeholder="პირადი ნომერი" name="personal" value={newUser.personal} onChange={handleClientChange} autoComplete="off" 
                            onInput={(e) => {
 
                                if (e.target.value.length > 11) { 
                                    e.target.value = e.target.value.substring(0, 11);
                                }
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();

                            }}
                            />
                        <div className={cl.crmIcon}>
                            <Id />
                        </div>
                    </div>
                    {validates && validates.personal &&
                        <div className={cl.errorMsg} >{validates.personal.message}</div>}
                </div>


                <div className={cl.inp2col2} style={{ marginBottom: 0 }}> 
                    <div className={validates && validates.mobile ? cl.groupInput + ' errorInput'  : cl.groupInput}>
                            <PhoneInput
                                defaultCountry="ge"
                                value={newUser.mobile}
                                defaultMask="... ...-..."
                                hideDropdown={false}
                                name="mobile"
                                onChange={(phone) => handlePhoneChange(phone)}
                            />
                        {validates && validates.mobile &&
                            <div className={cl.errorMsg} >{validates.mobile.message}</div>}

                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.email ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="ელ-ფოსტა" name="email" value={newUser.email} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}><At /></div>
                        </div>
                        {validates && validates.email &&
                            <div className={cl.errorMsg} >{validates.email.message}</div>}

                    </div>

                </div>


                <div className={cl.inp2col} style={{ marginBottom: 0 }}>
                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="password" className={validates && validates.password ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="პაროლი" name="password" value={newUser.password} onChange={handleClientChange}  autoComplete="new-password"  />
                            <div className={cl.crmIcon}><Lock /></div>
                        </div>
                        {validates && validates.password &&
                            <div className={cl.errorMsg} >{validates.password.message}</div>}
                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="password" className={validates && validates.password ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="პაროლი" name="password2" value={newUser.password2} onChange={handleClientChange}   autoComplete="new-password" />
                            <div className={cl.crmIcon}><Lock /></div>
                        </div>
            
                    </div>

                </div>





                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>
            </Modal>
        </div>
    );
};

export default CurrentUserModal;